export default (payload) => ({
  type: 'UPDATE_HARDWARE_STATE',
  payload,
});
